import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';
import { translate } from '../Services/translation';
import { trackAddToCart } from '../Shared/Tracking'; 

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }

    render() {
        return (
            <span ref={this.buttonRef}>
                <BuyButton {...this.props} onClick={(articleNumber, quantityFieldId, trackingProduct, openMiniCartAtCheckout) => {
                    trackAddToCart(trackingProduct, quantityFieldId ? document.getElementById(quantityFieldId).value : 1);
                    this.props.addToCart(this.buttonRef.current, articleNumber, quantityFieldId, openMiniCartAtCheckout)
                }} />
            </span>
        );
    }
}

const mapStateToProps = state => {
    return { }
}

const mapDispatchToProps = dispatch => {
    return {
        /**
         * @param buttonDomNode
         * @param articleNumber
         * @param quantityFieldId
         * @param {boolean}openMiniCartAtCheckout
         */
        addToCart: (buttonDomNode, articleNumber, quantityFieldId, openMiniCartAtCheckout) => {
            const nodeIdToShowNotification = buttonDomNode.id = Date.now();
            dispatch(addToCart({ 
                articleNumber, 
                quantity: quantityFieldId ? document.getElementById(quantityFieldId).value : 1,
                nodeIdToShowNotification,
                notificationMessage: translate('tooltip.addedtocart'),
                hash: Date.now(),
                openMiniCartAtCheckout
            }));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);
